import { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles/theme.sass";

// pages


import Footer from "./components/Layout/Footer/Footer";
import NavBar from "./components/Layout/NavBar/NavBar";
import NavBarPanel from "./components/Layout/NavBarPanel/NavBarPanel";
// data
import { marked } from "marked";
import AppRoutes from "./Routes";
import "./code_theme.css";
import GlobalStateProvider from "./hooks/useGlobalContext";
import GoToTop from "./components/functional/GoToTop";
import browserDetect from "browser-detect";
import WaveDots from "./components/pos_abs/WaveDots";
function App() {
  // functionality

  const [currentPage, setCurrentpage] = useState("");
  const scrollRef = useRef<HTMLElement>(null);

  // The scrollbar now sits inside the frame, so full-bleed rows like the footer
  // have to reach past it to touch the border. Measure it rather than assume:
  // the width differs per browser and is 0 where scrollbars overlay content.
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const measureGutter = () => {
      const gutter = el.offsetWidth - el.clientWidth;
      document.documentElement.style.setProperty("--sb-gutter", `${gutter}px`);
    };
    measureGutter();
    window.addEventListener("resize", measureGutter);
    return () => window.removeEventListener("resize", measureGutter);
  }, []);

  const result = browserDetect();

  function handlePage(currentPage: string) {
    setCurrentpage(currentPage);
  }

  // set marked options
  marked.setOptions({
    breaks: true,
    async: true,
  });

  const header = result.mobile ? <NavBarPanel currentPage={currentPage} /> : <NavBar />;

  // Dom Render
  return (
    <HelmetProvider>
      <GlobalStateProvider>
        <Router>
          {header}
          <WaveDots />
          <main className="app-scroll" ref={scrollRef}>
            <AppRoutes handlePage={handlePage} />
            <Footer />
          </main>
          <GoToTop />
        </Router>
      </GlobalStateProvider>
    </HelmetProvider>
  );
}

export default App;
